import React, { useEffect, useState } from "react";
import { FlowParts } from "../Parts/flowParts";
import { ProductsView } from "../Views/productsView";
import { useForm } from "react-hook-form";

export const ProductsPage = (props) => {

    window.scrollTo(0,0)
    
    
    const [ produts, setProducts ] = useState(0)
    const { register, handleSubmit,  formState: { errors } } = useForm({
        defaultValues: props.defaultValue.product
    })

    useEffect(() => {
        if(props.defaultValue.product === false){
            if(props.type === 1){
                
                setProducts({
                    buyDate:null,
                    name:'ガス衣類乾燥機 乾太くん',
                    kantakun:'8kg',
                    maker:'RINAI',
                })
            }else if(props.type === 2){
                setProducts({
                    buyDate:null,
                    name:'Siセンサーコンロ',
                    kantakun:null,
                    maker:'RINAI',
                })
            }
           
        }else{
            setProducts(props.defaultValue.product)
        }
        
    },[])


    const onSubmit = (currentInput) => {
        
        let recoilSetProducts
        if(props.type === 1){
            props.setProducts({
                ...produts,
                buyDate: currentInput.buyDate,
                kantakun: produts.kantakun,
                name:produts.name,
                maker: 'RINNAI',
            })
            recoilSetProducts = `ガス衣類乾燥機 乾太くん 【${produts.kantakun}】 / 購入日：${currentInput.buyDate}`
           
        }else if(props.type === 2){
            props.setProducts({
                ...produts,
                buyDate: currentInput.buyDate,
                maker: currentInput.maker,
                name:produts.name
            })
            recoilSetProducts = `${produts.name} 【${currentInput.maker}】 / 購入日：${currentInput.buyDate}`
        }else{}
        
        props.next()

    }

    return (
        <div className="select">
            <FlowParts {...{flow:'flow1'}}></FlowParts>
            <div className="select_content">
                <form onSubmit={handleSubmit(onSubmit)}>
                    {
                    produts !== 0 &&
                        <ProductsView {...{
                            cource:props.type, 
                            register, 
                            produts, 
                            setProducts,
                            errors}}>
                            
                        </ProductsView>
                    }
                    <div className="block1 w-500">
                        <div className="block1_1"><button className="btn5" type="submit">次へ</button></div>
                        <div className="block1_2"><a className="btn6" onClick={props.prev}>戻る</a></div>
                    </div>
                </form>
            </div>
        </div>
    )
}